import React from "react";

const styles = {
  Confirmado: "text-[#C9A227] border-[#C9A227]/40 bg-[#C9A227]/10",
  Pendiente: "text-amber-300 border-amber-500/40 bg-amber-500/10",
  Completado: "text-[#A0A0A5] border-[#2E2F33] bg-[#1C1D20]",
  Cancelado: "text-red-300 border-red-500/40 bg-red-500/10",
  Activo: "text-emerald-300 border-emerald-500/40 bg-emerald-500/10",
  "En viaje": "text-[#C9A227] border-[#C9A227]/40 bg-[#C9A227]/10",
  Descanso: "text-[#A0A0A5] border-[#2E2F33] bg-[#1C1D20]",
  Diamante: "text-[#F5F5F5] border-[#C9A227] bg-[#C9A227]/15",
  Oro: "text-[#D4AF37] border-[#C9A227]/40 bg-[#C9A227]/10",
  Plata: "text-[#A0A0A5] border-[#2E2F33] bg-[#1C1D20]",
  Nuevo: "text-emerald-300 border-emerald-500/40 bg-emerald-500/10",
};

export const StatusBadge = ({ status, className = "" }) => {
  const s = styles[status] || styles.Completado;
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 text-[10px] font-display font-semibold uppercase tracking-wider border rounded-full ${s} ${className}`}
      data-testid={`status-badge-${status?.toLowerCase().replace(/\s+/g, "-")}`}
    >
      <span className="w-1 h-1 rounded-full bg-current" />
      {status}
    </span>
  );
};

export default StatusBadge;
